import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { PdfAuthorNote } from "./pdf-author-note"
import { PdfHtmlDiff } from "./pdf-html-diff"
import { Else } from "lib/@components/else"
import { PdfRichTextBlock } from "./pdf-rich-text-block"
import { sanitizeAmendsHtml } from "../../project/amends/lib/sanitize-amends-html"
import { sanitizePdfHtml } from "./pdf-formatters"

export function PdfRichTextSection({ title, originalHtml, draftHtml, note, changed, pageBreakAfter = "auto" }) {
    const safeOriginalHtml = sanitizeAmendsHtml(originalHtml)
    const safeDraftHtml = sanitizeAmendsHtml(draftHtml)
    const safeNote = buildSanitizedNote(note)
    const hasNote = Boolean(safeNote?.content)

    return (
        <Box component="tbody" sx={{ pageBreakAfter, breakAfter: pageBreakAfter }}>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "#1f2937" }}>{title}</Typography>
                        <Typography sx={{ fontWeight: 700, fontSize: "10px", color: changed ? "#2b95a2" : "#617184" }}>
                            {changed ? "Changes Highlighted" : "No Changes"}
                        </Typography>
                    </Stack>
                </Box>
            </Box>
            <Box component="tr">
                <Box component="td" sx={getContentCellSx("left", changed)}>
                    <If truthy={changed}>
                        <PdfHtmlDiff
                            text={safeOriginalHtml}
                            original={safeDraftHtml}
                            other={safeDraftHtml}
                            showRemoved
                        />
                        <Else>
                            <PdfRichTextBlock html={safeOriginalHtml} />
                        </Else>
                    </If>
                </Box>
                <Box component="td" sx={getContentCellSx("right", changed)}>
                    <If truthy={changed}>
                        <PdfHtmlDiff text={safeDraftHtml} original={safeOriginalHtml} other={safeOriginalHtml} />
                        <Else>
                            <PdfRichTextBlock html={safeDraftHtml} />
                        </Else>
                    </If>
                </Box>
            </Box>
            <If value={hasNote}>
                <Box component="tr" sx={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <Box
                        component="td"
                        colSpan={2}
                        sx={{ p: 0, pt: "10px", pb: "24px", pageBreakInside: "avoid", breakInside: "avoid" }}
                    >
                        <PdfAuthorNote note={safeNote} />
                    </Box>
                </Box>
            </If>
        </Box>
    )
}

const sectionHeadingCellSx = {
    p: 0,
    pb: "12px",
    borderBottom: "1px solid #d7dce2",
}

function getContentCellSx(side, changed) {
    return {
        p: 0,
        pt: "14px",
        verticalAlign: "top",
        ...(side === "left" ? { pr: "20px" } : { pl: "20px" }),
        ...(changed && side === "right" ? { borderLeft: "1px solid #d7dce2" } : {}),
    }
}

function buildSanitizedNote(note) {
    if (!note) return note

    return {
        ...note,
        content: sanitizePdfHtml(note.content),
    }
}
